export var AUTH_TOKEN_KEY = 'auth';
export var STAGING_USER_ID_KEY = 'devUserId';
export var STAGING_X_REFRESH_TOKEN = 'devXRefreshId';
export var STAGING_AUTH_TOKEN_KEY = 'stagingAuth';
export var USER_ID_KEY = 'userId';
export var X_REFRESH_TOKEN = 'xRefreshId';
export var DEV_AUTH_TOKEN_KEY = 'devAuth';
export var DEV_USER_ID_KEY = 'devUserId';
export var DEV_X_REFRESH_TOKEN = 'devXRefreshId';
var isAlgoliaDev = process.env.ALGOLIA_MODE === 'dev'; // Introduce fall-back for when it's running on the API Reference (no ENV injection for client-side)

var ALGOLIA_APP_ID = isAlgoliaDev ? process.env.DEV_ALGOLIA_APP_ID : process.env.ALGOLIA_APP_ID || 'BH4D9OD16A';
var ALGOLIA_API_KEY = isAlgoliaDev ? process.env.DEV_ALGOLIA_API_KEY : process.env.ALGOLIA_API_KEY || '24d25bcd4ee938d065f5194164c2686d';
var ALGOLIA_INDEX_NAME = isAlgoliaDev ? process.env.DEV_ALGOLIA_INDEX_NAME : process.env.ALGOLIA_INDEX_NAME || 'frame';
var FORUM_URL = "https://forum.frame.io/";
var SITE_NAME = process.env.SITE_NAME;
var API_REFERENCE_URL = 'https://developer.frame.io/api/reference/';
var CHANGELOGS_URL = 'https://developer.frame.io/changelogs/';
var GUIDES_URL = 'https://developer.frame.io/docs/';
var HEADER_HEIGHT = 72;
export { HEADER_HEIGHT, ALGOLIA_API_KEY, ALGOLIA_APP_ID, ALGOLIA_INDEX_NAME, SITE_NAME, FORUM_URL, API_REFERENCE_URL, CHANGELOGS_URL, GUIDES_URL };